import {
  EmptyInput,
  Flex,
  InputGroup,
  InputRow,
  StyledToggleButton,
  TextInput,
  ToggleButtonIconWrapperBase,
  ToggleInput,
} from '@equifinance/shared';
import styled from 'styled-components';
import { PaddedSection } from '../Account/components/Section';
import { useBrokerContext } from '../../contexts/broker';
import PersonalDetailSection from './components/PersonalDetailSection';
import PasswordSection from './components/PasswordSection';

const Container = styled.div`${({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.padding[4]};
  color: ${theme.colours.neutral[2]};
  font-size: ${theme.fontSize[2]};
`}`;

export const SectionHeader = styled.div`${({ theme }) => `
  display: flex;
  justify-content: space-between;
  background: ${theme.colours.primary[11]};
  border-radius: ${theme.borderRadius[1]};
  color: ${theme.colours.primary[1]};
  padding: ${theme.padding[1]} ${theme.padding[7]};
  font-size: ${theme.fontSize[1]};
  line-height: ${theme.fontSize[3]};
  font-weight: 600;
`}`;

export const SectionContainer = styled.div<{ isEditing?: boolean }>`${({ theme, isEditing }) => `
  ${isEditing && `
    background-color: ${theme.colours.tertiary[6]};
    border-radius: 0 0 ${theme.padding[2]} ${theme.padding[2]};
  `};
  ${InputGroup} {
    max-width: ${theme.smallFooterWidth};
  }
  ${InputRow} > div {
    flex: 1;
  }
`}`;

const RoleToggleContainer = styled(Flex)<{ checked: boolean }>`${({ theme, checked }) => `
  gap: ${theme.padding[3]};
  font-weight: ${theme.fontWeight.bold};

  > div {
    width: auto;
  }
  ${StyledToggleButton} {
    padding: 0;
    background: ${theme.colours.neutral[7]};
    pointer-events: none;
  }
  ${ToggleButtonIconWrapperBase} {
    border: ${theme.borderWidth[2]} solid ${checked === true ? theme.colours.primary[1] : theme.colours.neutral[4]};
  }
  path {
    fill: ${checked === true ? theme.colours.primary[1] : theme.colours.neutral[4]};
  }
`}`;

export default function ManageDetailsSection() {
  const { brokerDetails } = useBrokerContext();
  return (
    <PaddedSection
      id={brokerDetails.id}
      title="Manage Your Details"
      titleIcon=""
    >
      <Container>
        <PersonalDetailSection />
        <div>
          <SectionHeader>CONTACT DETAILS</SectionHeader>
          <SectionContainer>
            <InputGroup>
              <InputRow>
                <TextInput
                  id="personal-details-email-address"
                  value={brokerDetails.emailAddress}
                  onChange={() => {}}
                  label="Email Address"
                  disabled
                  required
                />
                <EmptyInput />
              </InputRow>
            </InputGroup>
          </SectionContainer>
        </div>
        <div>
          <SectionHeader>ROLE</SectionHeader>
          <SectionContainer>
            <InputGroup>
              <InputRow>
                <RoleToggleContainer checked={brokerDetails.isAdmin}>
                  <span>Admin</span>
                  <ToggleInput
                    id="personal-details-role"
                    value={brokerDetails.isAdmin}
                    onChange={() => {}}
                    disabled
                  />
                </RoleToggleContainer>
                <EmptyInput />
              </InputRow>
            </InputGroup>
          </SectionContainer>
        </div>
        <PasswordSection />
      </Container>
    </PaddedSection>
  );
}
